import * as React from "react";
import { Link } from "react-navi";
import { useFrontpage } from "../../../common/FrontpageProvider";
import InstantSearchInput from "../../../common/components/InstantSearchInput";
import LanguageDropdown from "../../../common/components/LanguageDropdown";

const Header: React.FC<{}> = ({}) => {
  const {state, t} = useFrontpage();

  const {project, popularPages, currentVariant, variants} = state.serverState;

  const handleShowSidebar = () => {
    const el = document.getElementById("sidebar");
    if(el){
      el.classList.toggle("is-hidden-touch")
    }
  }

  return <section className="hero is-success is-medium">
  <div className="hero-head">
    <nav className="navbar">
      <div className="container">
        <div className="navbar-brand">
          <Link className="navbar-item" style={{textDecoration: 'none', fontSize: '2em', fontWeight: 'bold', color: 'white'}} href={`/${currentVariant.slug}`}>
            {project.logoUrl && <img src={project.logoUrl} style={{marginRight: '5px'}}/> }
            <span className="ml-1">{project.name}</span>
          </Link>

          <a role="button" className="navbar-burger" aria-label="menu" aria-expanded="false" onClick={handleShowSidebar}>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </a>
        </div>

        <div className="navbar-menu">
          {state.currentNote && <div className="navbar-item column is-6">
            <InstantSearchInput />
          </div>}

          <div className="navbar-end">
            {project.homePageUrl && <div className="navbar-item">
              <a href={project.homePageUrl} className="button is-light" target="_blank">{t("Home page")}</a>
            </div>}

            {variants.length > 1 && <div className="navbar-item">
              <LanguageDropdown />
            </div>}
          </div>
        </div>
      </div>
    </nav>
  </div>

  {!state.currentNote &&
  <div className="hero-body">
    <div className="container" style={{maxWidth: '800px'}}>
      <h1 className="title is-1">
        {t("How can we help?")}
      </h1>
      <div className="control has-icons-left">
        <InstantSearchInput />
      </div>
      <br/>

      <h2 className="title">{t("Top articles")}</h2>
      {popularPages.map(x =>
        <Link className="title is-4 popular" style={{display: "block"}} key={x.id} href={`/${currentVariant.slug}/notes/${x.slug}`}>{x.title}</Link>
      )}
    </div>
  </div>}
</section>
}

export default Header;